import { put, select, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import Cookies from 'universal-cookie';

const cookies = new Cookies();

import cloneDeep from 'helpers/cloneDeep';

import {
  setOrganizationsData,
  setUserData,
  setUnautorized,
  setCurrentOrganization,
  setOrganizationCount,
} from './actions';

import {
  UNAUTHORIZED,
  ORGANIZATIONS_DATA_ADD,
  USER_DATA_ADD,
} from './constants';

import {
  selectOrganizations,
  selectCurrentOrganization,
  selectOrganizationCount,
  selectUser,
  selectLoaded
} from './selectors';




export function* getUserData(action) {
  
  const { payload } = action;

  if (payload.status === 'success') {

    if (payload.data.token) {
      const hasCookie = cookies.get('userId');
      yield cookies.set('userId', payload.data.token, { path: '/', secure: true, sameSite: 'lax' });
      if (!hasCookie) location.reload();
    }
    yield put(setUserData(payload.data.user && payload.data.token ? payload.data.user : payload.data));

  } else if (payload.statusCode === 403) {
    yield cookies.remove('userId', { path: '/' });
    yield cookies.remove('intercom-session-dkobolus', { path: '/' });    
    yield put(setUnautorized());
    yield put(push('/'));    
  }

}

export function* getUserSaga() {
  yield takeLatest(USER_DATA_ADD, getUserData);
}



export function* saveOrganizationData(action) {

  const { payload } = action;

  const loaded = yield select(selectLoaded());
  const organizationCount = yield select(selectOrganizationCount());
  const userser = yield select(selectUser());

  const currentOrganization = yield select(selectCurrentOrganization());

  const countOrgs = !loaded || userser && Array.isArray(userser.organizations) && organizationCount < userser.organizations;

  if (payload && payload.status === 'success') {
    const thisOrganizations = payload.data;

    const organizations = yield select(selectOrganizations());

  

    const newOrganizations = cloneDeep(organizations);

    if (!newOrganizations || newOrganizations.length === 0) {
      newOrganizations[0] = thisOrganizations;
    } else if (newOrganizations) {
      for (let i = 0; i < newOrganizations.length; i++) {
        if (newOrganizations[i].organizationId === thisOrganizations.organizationId) {
          newOrganizations[i] = thisOrganizations;
          break;
        } else if (i === newOrganizations.length - 1) {
          newOrganizations[i+1] = thisOrganizations;
          break;
        }
      }
    }


    if (currentOrganization && currentOrganization.organizationId === thisOrganizations.organizationId) {
      yield put(setCurrentOrganization(thisOrganizations));
    }


    if (newOrganizations) {
      const sortOrgs = newOrganizations.sort((a, b) => {
        if (a.title && b.title)  return a.title.localeCompare(b.title);
      });
      yield put(setOrganizationsData(sortOrgs));
      if (countOrgs) yield put(setOrganizationCount());
    }


  } else if (payload && payload.status === 'error') {
    if (countOrgs) yield put(setOrganizationCount());
  }
  
}


export function* getOrganizationSaga() {
  yield takeLatest(ORGANIZATIONS_DATA_ADD, saveOrganizationData);
}



export function* setUnautorizedAccess(action) {

  if (action && action.payload.statusCode === 401) {
    yield cookies.remove('userId', { path: '/' });
    yield cookies.remove('intercom-session-dkobolus', { path: '/' });    
    yield put(setUnautorized());
    yield put(push('/unauthorized'));    
  }

}

export function* unautorizedAccess() {
  yield takeLatest(UNAUTHORIZED, setUnautorizedAccess);
}

// All sagas to be loaded
export default [
  unautorizedAccess,
  getOrganizationSaga,
  getUserSaga,
];
